import styled from "styled-components";

export const SearchContainer = styled.div`
  max-width: 1440px;
  padding: 0 20px;
  width: 100%;
  height: 100%;
  position: relative;
  margin: 0 auto;
  .form {
    max-width: 300px;
    width: 100%;
    height: 50px;
    margin: 0 auto;
    position: relative;
    input {
      width: 100%;
      height: 100%;
      border-radius: 50px;
      border: 2px solid #000;
      padding: 0 40px 0 20px;
      &:focus {
        border: 2px solid #000 !important;
        box-shadow: none;
        outline: none;
      }
    }
    button {
      position: absolute;
      top: 50%;
      right: 20px;
      transform: translateY(-50%);
      width: 24px;
      height: 24px;
      font-size: 24px;
      background: transparent;
      svg {
        display: block;
        margin: 0;
      }
    }
  }
  .keyword {
    text-align: center;
    margin: 50px 0;
    font-size: larger;
  }
  .section {
    margin-bottom: 100px;
    &:last-child {
    }
  }
  .title {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 20px;
  }
  &.theme-0 {
    .keyword .color,
    .title strong {
      color: #ff0000;
    }
  }
  &.theme-2 {
    max-width: 1240px;
    .title strong {
      color: #999;
    }
    .keyword .color {
      color: #999;
    }
    .form {
      max-width: 50%;
      input {
        border: none;
        background: rgb(249, 248, 246);
        &:focus {
          outline: none;
          border: none !important;
        }
      }
    }
  }
  &.theme-4 {
    .keyword .color,
    .title strong {
      color: #3b8ef6;
    }
    .form {
      max-width: 400px;
      input {
        background: #f5f5f5;
        border: 1px solid #e7e7e7;
        border-radius: 10px;
        &:focus {
          border: 1px solid #e7e7e7 !important;
        }
      }
    }
  }
  @media screen and (max-width: 1050px) {
    .title {
      font-size: 20px;
    }
    .section {
      margin-bottom: 70px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .form button {
      font-size: larger;
    }
    &.theme-0 {
    }
    &.theme-2 {
      .form {
        max-width: 400px;
        height: 40px;
      }
    }
    &.theme-4 {
      .form {
        height: 40px;
      }
    }
  }
  @media screen and (max-width: 767px) {
    .title {
      font-size: 18px;
    }
    .section {
      margin-bottom: 50px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    &.theme-0 {
    }
    &.theme-2 {
    }
    &.theme-4 {
    }
  }
`;
